/**
 * Authentication Module
 * Centralized exports for all authentication-related functionality
 */

// Types
export * from './types';

// Storage
export * from './storage';

// Services
export { GoogleAuthService, getGoogleAuthService } from './services/googleAuth';
export { AuthApiService, getAuthApiService } from './services/authApi';

// Providers
export { AuthProvider, useAuth, useAuthToken, useIsAuthenticated } from './providers/AuthProvider';

// Components
export {
  PrivateRouteGuard,
  PublicRouteGuard,
  ConditionalAuthGuard,
  withPrivateRoute,
  withPublicRoute,
} from './components/AuthGuard';

// Hooks
export {
  usePrivateRoute,
  usePublicRoute,
  useAuthState,
  useAuthActions,
  useRoleGuard,
  usePermissionGuard,
  useAuthError,
  useAuthLoading,
} from './hooks/useAuthGuard';

// API Integration
export {
  createAuthTokenProvider,
  createAuthErrorInterceptor,
  createAuthenticatedHttpClient,
  getAuthenticatedHttpClient,
  resetAuthenticatedHttpClient,
} from './apiIntegration';

// Authenticated API Client
export {
  apiClient,
  resetApiClient
} from './apiClient';
